import React from 'react';
import projectImage from '../img/P3.png';
import Navbar from './Navbar';
import { motion } from "framer-motion";
import { FaGithub, FaFigma } from "react-icons/fa";
import { Link } from "react-router-dom";

const Project = () => {
  return (
    <div>
      <Navbar />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5 }}
        id='about'
        className="mx-auto px-4 md:px-20"
      >
        <h2 className="text-4xl sm:text-4xl font-bold pl-4 pt-20">Project Title: Portfolio</h2>

        <div className="max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center h-full py-10">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="h-75 w-75 ml-4 mr-4 pr-4"
          >
            <img
              src={projectImage}
              alt="Project Screenshot"
              className="mx-auto w-full shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.5 }}
            className="flex flex-col justify-center h-full   "
          >
            <div className="items-center justify-center">
              <h2 className="text-3xl sm:text-4xl font-bold pl-4">Key tools and technologies:</h2>
              <ul className="flex flex-wrap justify-center pb-5 text-xl sm:text-2xl font-bold pt-2">
                <li className="pl-4">HTML5</li>
                <li className="pl-4">CSS3</li>
                <li className="pl-4">React JS</li>
                <li className="pl-4">Tailwind CSS</li>
              </ul>
            </div>

            <div className="items-center justify-center">
              <ul className="flex justify-center pb-5 text-xl sm:text-2xl font-bold">
                <li className="pl-4">
                  <Link to="https://github.com/45aman"><FaGithub size="3.3rem" /></Link>
                </li>
                <li className="pl-4">
                  <Link to="https://www.figma.com/files/recents-and-sharing/recently-viewed?fuid=1087804051819283768"><FaFigma size="3.3rem" /></Link>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>

        <h1 className="text-4xl sm:text-3xl font-bold pt-10 pl-4">Project Description:</h1>
        <div className="px-4 md:px-20">
          <p className="py-4">
          I have created my portfolio using React.js and Tailwind CSS, showcasing my diverse range of projects. The portfolio includes detailed descriptions of each project, along with links to their corresponding GitHub repositories and Figma designs. Additionally, I have incorporated my contact details and links to all my social media platforms, providing a seamless means of connecting with me.

<br/>Furthermore, my portfolio showcases my resume, highlighting my skills, experiences, and educational background. This comprehensive representation serves as a testament to my expertise in web development and design, as well as my passion for continuous learning and growth.

<br/>Through this project, I aimed to create an interactive and visually appealing portfolio that showcases my capabilities as a developer, while also demonstrating my proficiency in utilizing the power of React.js and Tailwind CSS. The user-friendly design and seamless navigation make it easy for visitors to explore my projects and access additional information about me.

<br/>I take great pride in this portfolio as it reflects my dedication and commitment to my craft. It serves as a platform to showcase my creativity and problem-solving skills, enabling me to stand out in the competitive world of web development
          </p>

          {/* <div>
            <button
              type="button"
              className="text-white bg-gradient-to-r from-cyan-400 via-cyan-500 to-cyan-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
            >
              Video Link
            </button>
          </div> */}
        </div>
      </motion.div>
    </div>
  );
};

export default Project;
